(function () {
    'use strict';

    var module = angular.module("imApp");

    module.factory("consignmentService", ['$q', '$ihttp', 'p2DataTaskService', function ($q, $ihttp, p2DataTaskService) {
        var service = {
            loaded: false,
            p2ConsignmentSave: {
                saveok: ''
            },
            p2ConsignmentConsignmentOlList: {
                records: []
            },
            p2ConsignmentConsignmentLineList: {
                records: []
            },
            p2ConsignmentConsignmentLinePickList: {
                records: []
            },
            p2PortalUserVariableSetWs: {},
            p2ConsignmentAssignSb: {},
            p2ConsignmentRefreshWeightVolum: {},
            p2DeliverConsignment: {},
            genericFunction: function (method_nr, parms) {
                var deferred = $q.defer();

                var parms_genericFunction = {
                    method: method_nr,
                    parameters: parms
                };

                $ihttp.post(parms_genericFunction).then(function (data) {
                    service.loaded = true;
                    deferred.resolve(data);
                });

                return deferred.promise;
            },
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 322,
                    parameters: parms || {}
                });
            },
            loadStockTransferLoadConsignmentPrePickList: function (stocktransfer_keyno) {
                return p2DataTaskService.call(1055, {
                    stocktransfer_keyno: stocktransfer_keyno
                });
            },
            listStockLocations: function (parms) {
                return $ihttp.post({
                    method: 1051,
                    parameters: parms || {}
                });
            },
            loadP2ConsignmentConsignmentOlList: function (consignment_keyno) {
                var deferred = $q.defer();

                var parmsP2ConsignmentConsignmentOlList = {
                    method: 326,
                    parameters: {
                        consignment_keyno: consignment_keyno
                    }
                };

                $ihttp.post(parmsP2ConsignmentConsignmentOlList).then(function (data) {
                    angular.copy(data, service.p2ConsignmentConsignmentOlList.records);
                    service.loaded = true;
                    deferred.resolve();
                });

                return deferred.promise;
            },
            loadP2ConsignmentConsignmentLineList: function (consignment_keyno) {
                var deferred = $q.defer();

                var parmsP2ConsignmentConsignmentLineList = {
                    method: 327,
                    parameters: {
                        consignment_keyno: consignment_keyno
                    }
                };

                $ihttp.post(parmsP2ConsignmentConsignmentLineList).then(function (data) {
                    angular.copy(data, service.p2ConsignmentConsignmentLineList.records);
                    service.loaded = true;
                    deferred.resolve();
                });

                return deferred.promise;
            },
            createCargonizerConsignment: function (consignmentId, deliveryMethod, colliCount, weightValue, volumeValue) {
                return $ihttp.post({
                    method: 348,
                    parameters: {
                        consignment_keyno: consignmentId,
                        deliverymethod_no: deliveryMethod,
                        colli: colliCount,
                        weight: weightValue,
                        volum: volumeValue
                    }
                });
            },
            updateCargonizerConsignment: function (consignmentId) {
                return $ihttp.post({
                    method: 418,
                    parameters: {
                        consignment_keyno: consignmentId
                    }
                });
            },
            completeConsignmentInWebshop: function (params) {
                return p2DataTaskService.call(1437, params);
            },
            consignmentWebshopPreValidate: function (params) {
                return p2DataTaskService.call(1575, params);
            },
            mergeConsignmentCollies: function (params) {
                return p2DataTaskService.call(1428, params);
            },
            splitConsignmentCollies: function (params) {
                return p2DataTaskService.call(1430, params);
            },
            listCollis: function (parms) {
                return $ihttp.post({
                    method: 439,
                    parameters: parms || {}
                });
            },
            loadP2ConsignmentConsignmentLinePickList: function (consignment_keyno) {
                var deferred = $q.defer();

                var parmsP2ConsignmentConsignmentLinePickList = {
                    method: 615,
                    parameters: {
                        consignment_keyno: consignment_keyno
                    }
                };

                $ihttp.post(parmsP2ConsignmentConsignmentLinePickList).then(function (data) {
                    angular.copy(data, service.p2ConsignmentConsignmentLinePickList.records);
                    service.loaded = true;
                    deferred.resolve();
                });

                return deferred.promise;
            },
            getP2PortalUserVariableSetWs: function (variablename, variablevalue) {
                var deferred = $q.defer();

                var parmsP2PortalUserVariableSetWs = {
                    method: 616,
                    parameters: {
                        variablename: variablename,
                        variablevalue: variablevalue
                    }
                };

                $ihttp.post(parmsP2PortalUserVariableSetWs).then(function (data) {
                    service.p2PortalUserVariableSetWs = angular.copy(data[0]);
                    service.loaded = true;
                    deferred.resolve();
                });

                return deferred.promise;
            },
            getP2ConsignmentAssignSb: function (consignment_keyno) {
                var deferred = $q.defer();

                var parmsP2ConsignmentAssignSb = {
                    method: 415,
                    parameters: {
                        consignment_keyno: consignment_keyno
                    }
                };

                $ihttp.post(parmsP2ConsignmentAssignSb).then(function (data) {
                    service.p2ConsignmentAssignSb = angular.copy(data[0]);
                    service.loaded = true;
                    deferred.resolve();
                });

                return deferred.promise;
            },
            assignItems: function (edit) {
                return $ihttp.post({
                    method: 415,
                    parameters: edit
                });
            },
            saveConsignmentHead: function (params) {
                var deferred = $q.defer();

                var parmsSaveConsignmentHead = {
                    method: 413,
                    parameters: params
                };

                $ihttp.post(parmsSaveConsignmentHead).then(function (data) {
                    angular.copy(data[0], service.p2ConsignmentSave);
                    deferred.resolve();
                });

                return deferred.promise;
            },
            deleteAssign: function (item) {
                return $ihttp.post({
                    method: 3557,
                    parameters: item
                });
            },
            deliverConsignment: function (parms) {
                var deferred = $q.defer();

                var parms_deliverConsignment = {
                    method: 418,
                    parameters: parms ?? {}
                };

                $ihttp.post(parms_deliverConsignment).then(function (data) {
                    service.p2DeliverConsignment = angular.copy(data[0]);
                    service.loaded = true;
                    deferred.resolve();
                });

                return deferred.promise;
            },
            unloadStockTransferAll: function (stocktransfer_keyno) {
                return p2DataTaskService.call(1064, {
                    stocktransfer_keyno: stocktransfer_keyno
                });
            },
            printLabelCargonizerApi: function (edit) {
                return $ihttp.post({
                    method: 2653,
                    parameters: edit
                });
            },
            rollbackItem: function (parms) {
                return $ihttp.post({
                    method: 2253,
                    parameters: parms
                });
            },

            getProdKeyname: function (searchtext) {
                return $ihttp.post({
                    method: 3110,
                    parameters: {
                        searchtext: searchtext
                    }
                });
            },
            getEstimatedFreight: function (consignment_keyno, deliverymethod_no, colli, weight, volum) {
                return $ihttp.post({
                    method: 350,
                    parameters: {
                        consignment_keyno: consignment_keyno,
                        deliverymethod_no: deliverymethod_no,
                        colli: colli,
                        weight: weight,
                        volum: volum
                    }
                });
            },
            handleEstimatedFreight: function (consignment_keyno, prod_id_freight, est_freight) {
                return $ihttp.post({
                    method: 3195,
                    parameters: {
                        consignment_keyno: consignment_keyno,
                        prod_id_freight: prod_id_freight,
                        est_freight: est_freight
                    }
                });
            },
            getOrderlineProdSum: function (consignment_keyno, prod_id) {
                return $ihttp.post({
                    method: 3199,
                    parameters: {
                        consignment_keyno: consignment_keyno,
                        prod_id: prod_id
                    }
                });
            },
        };

        return service;
    }]);
})();
